import { useContext, useEffect, useState } from 'react';
import { ImagesContext } from '../../contexts/ImagesContext';
import ModalComponent from '../../components/ModalComponent';
import BlocksContainerExport from '../../components/Blocks/Core/BlocksContainerExport';
import { PublishContext } from '../../contexts/PublishContext';

interface Props {
  open: boolean,
  pageId: string
  pageTitle: string
  handleClose: () => void
  handleSave: () => void
}

const Index = (props: Props) => {
  const {
    open,
    pageTitle,
    pageId,
    handleClose: incomingHandleClose,
    handleSave: incomingHandleSave,
  } = props;

  const { isInCooldown, message, setIsInCooldown } = useContext(PublishContext);
  const { isLoading } = useContext(ImagesContext);
  const [canPublish, setCanPublish] = useState(false);
  const [loadingVideos, setLoadingVideos] = useState(false);

  const handleClose = () => {
    setIsInCooldown(false);
    incomingHandleClose();
  };

  const handleSave = async () => {
    setCanPublish(false);
    await incomingHandleSave();
    setCanPublish(true);
  };

  const loadVideosConcurrently = async (videoElements: HTMLVideoElement[]) => {
    await Promise.all(videoElements.map((video) => {
      if (video.readyState < 2) {
        return new Promise((resolve) => {
          video.addEventListener('loadeddata', () => {
            resolve(true);
          }, { once: true });
        });
      }

      return Promise.resolve(true);
    }));

    setLoadingVideos(false);
  };

  // effects
  useEffect(() => {
    if (isLoading) return;

    // setup
    setLoadingVideos(true);
    const videoElements = document.querySelectorAll('video');

    // if there is no video, set loading to false
    if (videoElements.length === 0) {
      setLoadingVideos(false);
    } else {
      // foreach video element, check if video is loaded
      loadVideosConcurrently(Array.from(videoElements) as HTMLVideoElement[]);
    }
  }, [isLoading]);

  useEffect(() => {
    setCanPublish(false);

    const timer = setTimeout(() => {
      setCanPublish(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [open]);

  useEffect(() => {
    setCanPublish(canPublish);
  }, [canPublish, setCanPublish]);

  const verifyIfIsLoading = (): boolean => {
    if (!canPublish) {
      return true;
    }

    if (isLoading) {
      return true;
    }

    if (loadingVideos) {
      return true;
    }

    return false;
  };

  return (
    // translate the title Republish Page to japanese
    <ModalComponent
      title="ページ再公開"
      confirmButtonText="ページを再公開"
      loading={verifyIfIsLoading()}
      onConfirm={handleSave}
      show={open}
      backdrop="static"
      keyboard={false}
      closeModal={handleClose}
      centered
      animation={false}
    >
      <div>
        {isInCooldown && (
          <div className="alert alert-warning mb-3" style={{ fontSize: '0.8rem' }} role="alert">
            {message}
          </div>
        )}

        <div
          style={{
            fontSize: '2rem',
            color: '#000',
            width: '100%',
            textAlign: 'center',
          }}
        >
          プレビュー
        </div>
        <div style={{
          overflowY: 'auto',
          minHeight: '30vh',
          maxHeight: '50vh',
          opacity: 0.8,
          width: '100%',
          border: '2px solid #000',
          borderRadius: '4px',
          marginBottom: '1rem',
        }}
        >
          <div
            style={{
              pointerEvents: 'none',
            }}
          >
            <BlocksContainerExport pageId={pageId} />
          </div>
        </div>
      </div>

      <p className="mb-0">
        「
        {pageTitle}
        」
        を再公開しますか？
      </p>
    </ModalComponent>
  );
};

export default Index;
